<template>
    <div>
        <Documentos idSeccion="4"/>
    </div>
</template>

<script>
import Documentos from '@/components/Documentos'
import {mapState} from 'vuex'

export default {
    name: 'InformacionFinanciera',
    props: {
    },
    data() {
        return {
            variable: ''
        }
    },
    created() {
    },
    components: {
        Documentos
    },
    computed: {
        ...mapState(['token'])
    },
}
</script>

<style scoped>
